import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Home = () => {
  return <Wrapper></Wrapper>;
};

export default Home;
